var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BButton',{attrs:{"variant":"primary","disabled":String(_vm.identificationNumber).length < 8 || _vm.isLoading},on:{"click":_vm.loadData}},[(_vm.isLoading)?_c('span',[_c('i',{staticClass:"fa fa-spinner-third fa-spin mr-2"}),_vm._v("Kontaktuji registr ")]):_c('span',[_vm._v(" Předvyplnit údaje podle IČO ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }